import { Route, Routes } from 'react-router-dom'

import PaginaInicial from './pages/PaginaInicial.jsx'

import CatalogoAbeaEmpresas from './pages/ABEA/CatalogoAbeaEmpresas.jsx'
import CatalogoAbeaProdutos from './pages/ABEA/CatalogoAbeaProdutos.jsx'
import DadosEmpresaAbea from './pages/ABEA/DadosEmpresaAbea.jsx'
import DadosProdutoAbea from './pages/ABEA/DadosProdutoAbea.jsx'
import SobreABEA from './pages/ABEA/SobreABEA.jsx'

import SobreA2A2 from './pages/A2A2/SobreA2A2.jsx'
import CatalogoA2A2Empresas from './pages/A2A2/CatalogoA2A2Empresas.jsx'
import CatalogoA2A2Produtos from './pages/A2A2/CatalogoA2A2Produtos.jsx'
import DadosEmpresaA2A2 from './pages/A2A2/DadosEmpresaA2A2.jsx'
import DadosProdutoA2A2 from './pages/A2A2/DadosProdutoA2A2.jsx'

import CatalogoFair4ThemEmpresas from './pages/Fair4Them/CatalogoFair4ThemEmpresas.jsx'
import CatalogoFair4ThemProdutos from './pages/Fair4Them/CatalogoFair4ThemProdutos.jsx'
import DadosEmpresaFair4Them from './pages/Fair4Them/DadosEmpresaFair4Them.jsx'
import DadosProdutoFair4Them from './pages/Fair4Them/DadosProdutoFair4Them.jsx'
import SobreFair4Them from './pages/Fair4Them/SobreFair4Them.jsx'

import SobreBEA from './pages/BEA/SobreBEA.jsx'
import CatalogoBEAEmpresas from './pages/BEA/CatalogoBeaEmpresas.jsx'
import CatalogoBEAProdutos from './pages/BEA/CatalogoBeaProdutos.jsx'
import DadosEmpresaBEA from './pages/BEA/DadosEmpresaBEA.jsx'
import DadosProdutoBEA from './pages/BEA/DadosProdutoBEA.jsx'

import CatalogoRedutorEmpresas from './pages/Redutor/CatalogoRedutorEmpresas.jsx'
import CatalogoRedutorProdutos from './pages/Redutor/CatalogoRedutorProdutos.jsx'
import DadosEmpresaRedutor from './pages/Redutor/DadosEmpresaRedutor.jsx'
import DadosProdutoRedutor from './pages/Redutor/DadosProdutoRedutor.jsx'
import SobreRedutor from './pages/Redutor/SobreRedutor.jsx'

import CatalogoPSEmpresas from './pages/ProducaoSustentavel/CatalogoPSEmpresas.jsx'
import CatalogoPSProdutos from './pages/ProducaoSustentavel/CatalogoPSProdutos.jsx'
import DadosEmpresaPS from './pages/ProducaoSustentavel/DadosEmpresaPS.jsx'
import DadosProdutoPS from './pages/ProducaoSustentavel/DadosProdutoPS.jsx'
import SobrePS from './pages/ProducaoSustentavel/SobrePS.jsx'

import CatalogoDurocEmpresas from './pages/Duroc/CatalogoDurocEmpresas.jsx'
import CatalogoDurocProdutos from './pages/Duroc/CatalogoDurocProdutos.jsx'
import DadosEmpresaDuroc from './pages/Duroc/DadosEmpresaDuroc.jsx'
import DadosProdutoDuroc from './pages/Duroc/DadosProdutoDuroc.jsx'
import SobreDuroc from './pages/Duroc/SobreDuroc.jsx'

import CatalogoOvoCaipiraEmpresas from './pages/OvoCaipira/CatalogoOvoCaipiraEmpresas.jsx'
import CatalogoOvoCaipiraProdutos from './pages/OvoCaipira/CatalogoOvoCaipiraProdutos.jsx'
import DadosEmpresaOvoCaipira from './pages/OvoCaipira/DadosEmpresaOvoCaipira.jsx'
import DadosProdutoOvoCaipira from './pages/OvoCaipira/DadosProdutoOvoCaipira.jsx'
import SobreOvoCaipira from './pages/OvoCaipira/SobreOvoCaipira.jsx'


function Rotas() {
    return (
        <Routes>
            <Route exact path='/' element={<PaginaInicial />}></Route>

            {/* Rotas ABEA */}
            <Route exact path='/catalogo-abea/sobre' element={<SobreABEA />}></Route>
            <Route exact path='/catalogo-abea/empresas' element={<CatalogoAbeaEmpresas />}></Route>
            <Route exact path='/catalogo-abea/produtos' element={<CatalogoAbeaProdutos />}></Route>
            <Route exact path='/catalogo-abea/empresas/:slug' element={<DadosEmpresaAbea />}></Route>
            <Route exact path='/catalogo-abea/produtos/:slug' element={<DadosProdutoAbea />}></Route>

            {/* Rotas A2A2 */}
            <Route exact path='/catalogo-a2a2/sobre' element={<SobreA2A2 />}></Route>
            <Route exact path='/catalogo-a2a2/marcas' element={<CatalogoA2A2Empresas />}></Route>
            <Route exact path='/catalogo-a2a2/produtos' element={<CatalogoA2A2Produtos />}></Route>
            <Route exact path='/catalogo-a2a2/marcas/:slug' element={<DadosEmpresaA2A2 />}></Route>
            <Route exact path='/catalogo-a2a2/produtos/:slug' element={<DadosProdutoA2A2 />}></Route>

            {/* Rotas Fai4Them */}
            <Route exact path='/catalogo-fair4them/sobre' element={<SobreFair4Them />}></Route>
            <Route exact path='/catalogo-fair4them/empresas' element={<CatalogoFair4ThemEmpresas />}></Route>
            <Route exact path='/catalogo-fair4them/produtos' element={<CatalogoFair4ThemProdutos />}></Route>
            <Route exact path='/catalogo-fair4them/empresas/:slug' element={<DadosEmpresaFair4Them />}></Route>
            <Route exact path='/catalogo-fair4them/produtos/:slug' element={<DadosProdutoFair4Them />}></Route>

            {/* Rotas BEA */}
            <Route exact path='/catalogo-bea/sobre' element={<SobreBEA />}></Route>
            <Route exact path='/catalogo-bea/marcas' element={<CatalogoBEAEmpresas />}></Route>
            <Route exact path='/catalogo-bea/produtos' element={<CatalogoBEAProdutos />}></Route>
            <Route exact path='/catalogo-bea/marcas/:slug' element={<DadosEmpresaBEA />}></Route>
            <Route exact path='/catalogo-bea/produtos/:slug' element={<DadosProdutoBEA />}></Route>

            {/* Rotas Redutor da pegada de carbono */}
            <Route exact path='/catalogo-rpc/sobre' element={<SobreRedutor />}></Route>
            <Route exact path='/catalogo-rpc/empresas' element={<CatalogoRedutorEmpresas />}></Route>
            <Route exact path='/catalogo-rpc/produtos' element={<CatalogoRedutorProdutos />}></Route>
            <Route exact path='/catalogo-rpc/empresas/:slug' element={<DadosEmpresaRedutor />}></Route>
            <Route exact path='/catalogo-rpc/produtos/:slug' element={<DadosProdutoRedutor />}></Route>

            {/* Rotas Produção Sustentável */}
            <Route exact path='/catalogo-ps/sobre' element={<SobrePS />}></Route>
            <Route exact path='/catalogo-ps/empresas' element={<CatalogoPSEmpresas />}></Route>
            <Route exact path='/catalogo-ps/produtos' element={<CatalogoPSProdutos />}></Route>
            <Route exact path='/catalogo-ps/empresas/:slug' element={<DadosEmpresaPS />}></Route>
            <Route exact path='/catalogo-ps/produtos/:slug' element={<DadosProdutoPS />}></Route>

            {/* Rotas Duroc */}
            <Route exact path='/catalogo-duroc/sobre' element={<SobreDuroc />}></Route>
            <Route exact path='/catalogo-duroc/empresas' element={<CatalogoDurocEmpresas />}></Route>
            <Route exact path='/catalogo-duroc/produtos' element={<CatalogoDurocProdutos />}></Route>
            <Route exact path='/catalogo-duroc/empresas/:slug' element={<DadosEmpresaDuroc />}></Route>
            <Route exact path='/catalogo-duroc/produtos/:slug' element={<DadosProdutoDuroc />}></Route>

            {/* Rotas Ovo Caipira */}
            <Route exact path='/catalogo-ovo-caipira/sobre' element={<SobreOvoCaipira />}></Route>
            <Route exact path='/catalogo-ovo-caipira/empresas' element={<CatalogoOvoCaipiraEmpresas />}></Route>
            <Route exact path='/catalogo-ovo-caipira/produtos' element={<CatalogoOvoCaipiraProdutos />}></Route>
            <Route exact path='/catalogo-ovo-caipira/empresas/:slug' element={<DadosEmpresaOvoCaipira />}></Route>
            <Route exact path='/catalogo-ovo-caipira/produtos/:slug' element={<DadosProdutoOvoCaipira />}></Route>

            <Route exact path='*' element={<PaginaInicial />}></Route>
        </Routes>
    )
}

export default Rotas